import { useCallback } from 'react';
import { LocationValidationRequestDTO, ValidationResultDTO } from '@/shared/api/model';
import { useValidateLocationSelection } from '@/shared/api/client/location-management';
import { useTheme } from '@/components/common/ThemeProvider';
import { showErrorNotification } from '@/components/common/utils/notify';

export const useLocationValidation = () => {
    const { dark } = useTheme();
    
    const { 
        mutateAsync: validateLocation, 
        isPending: isValidating 
    } = useValidateLocationSelection({
        mutation: {
            onError: (error) => {
                console.error('Location validation failed:', error);
                showErrorNotification('Error', 'Failed to validate location selection', dark);
            }
        }
    });

    const validateLocationForConfig = useCallback(async (
        locationData: LocationValidationRequestDTO,
        configName: string
    ): Promise<ValidationResultDTO> => {
        try {
            const result = await validateLocation({
                data: locationData,
                params: { configName }
            });
            return result;
        } catch (error) {
            console.error('Location validation failed:', error);
            showErrorNotification('Error', 'Failed to validate location selection', dark);
            return {
                valid: false,
                errors: ['Validation failed due to server error']
            };
        }
    }, [validateLocation, dark]);

    return {
        validateLocationForConfig,
        isValidating
    };
};

export default useLocationValidation;